export class FlightChangeFlagModel {
  wasFlightChangeConfirmed: boolean = false;
}
